// extracted by mini-css-extract-plugin
export default {"text":"TableCell_text__JIvkr"};